import { Component, OnInit, Input, ViewChildren } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { EgretNotifications2Component } from '../egret-notifications2/egret-notifications2.component';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { LocalStoreService } from '../../services/local-store.service';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../services/global.service';
import { PassService } from '../../services/passEmitData.service';
import { DataService } from '../../services/data.service';
import { CheckDuplicatePopupComponent } from '../check-duplicate-popup/check-duplicate-popup.component';
import { NotificationsComponent } from '../notifications/notifications.component';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';

declare var gtag;
@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html',
})
export class HeaderSideComponent implements OnInit {
  @Input() notificPanel;
  @ViewChildren(EgretNotifications2Component) noti;
  public availableLangs = [
    {
      name: 'VN',
      code: 'vi',
      flag: 'flag-icon-vn',
    },
    {
      name: 'EN',
      code: 'en',
      flag: 'flag-icon-us',
    },
  ];
  currentLang = this.availableLangs[0];
  subscription: Subscription;
  titleMenu: string;
  state: string;
  helperLink: any;
  notiNumber: number = 0;
  phoneNumber: number = 0;
  menuList: any = [];
  public egretThemes;
  public layoutConf: any;
  public user: any;
  isDisplayHelp: boolean = true;
  isMobile: boolean;

  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public translate: TranslateService,
    public jwtAuth: AuthenticationService,
    private local: LocalStoreService,
    private pass: DataService,
    private globalSrv: GlobalService,
    private dialog: MatDialog,
    private notify: NotificationsComponent,
    private deviceService: DeviceDetectorService,
    private router: Router
  ) {
    this.isDisplayHelp = this.local.getItem('companySetting').isDisplayHelp
      ? this.local.getItem('companySetting').isDisplayHelp
      : false;
    this.menuList = [];
    this.local.getItem('menu')?.map((item) => {
      if (item.sub && item.sub.length > 0) {
        return item.sub.forEach((element) => {
          return this.menuList.push(element);
        });
      } else {
        return this.menuList.push(item);
      }
    });

    this.subscription = this.local.getLsChanges().subscribe((message) => {
      if (message) {
        this.user = this.local.getItem('currentUser');
      }
    });
    globalSrv.itemValue.subscribe((currentRoute: any) => {
      var menus = this.local.getItem("menu");
      var route = currentRoute.state.split("?");
      var path = route[0];
      var param = route[1];
      var urlParams = new URLSearchParams(param);
      var menu = menus.find(x=>x.State == path && x.Params?.["st"]?.toLowerCase() == urlParams.get("st")?.toLowerCase());
      if(menu == undefined && currentRoute.state.indexOf("404") == -1 && jwtAuth.currentRoute.indexOf(path) == -1){
        this.router.navigate(['/sessions/404']);
      }
      else{
        this.titleMenu = (menu && menu.Name) ? menu.Name : currentRoute.title;
      }
      this.state = currentRoute.state;
      let find = this.menuList.find((item) => item.state == currentRoute.state);
      if (find) {
        this.helperLink = find.helpLink;
        return;
      }
      this.helperLink = null;
    });

    this.currentLang = this.local.getItem('lang');
    if (!this.currentLang) {
      this.currentLang = this.availableLangs[0];
      this.local.setItem('lang', this.currentLang);
    }

    this.isMobile = this.deviceService.isMobile();
  }

  handleHelp() {
    window.open(this.helperLink, 'blank');
  }

  checkTheme() {
    if (this.titleMenu === 'Báo cáo hệ thống') {
      return true;
    }
    return false;
  }
  ngOnInit() {
    this.user = this.local.getItem('currentUser');
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    this.translate.use(this.currentLang.code);

    this.pass.currentMessage.subscribe((res) => {
      this.notiNumber = res;
    });
    this.pass.currentMessagePhoneBack.subscribe((res) => {
      this.phoneNumber = res;
    });
  }

  setLang(lng) {
    this.currentLang = lng;
    this.local.setItem('lang', this.currentLang);
    this.translate.use(lng.code);
  }

  changeTheme(theme) {
    // this.themeService.changeTheme(theme);
  }
  toggleNotific(typeLoad) {
    this.pass.changeTypeLoad(typeLoad.toString());
    this.notificPanel.toggle();
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'compact',
    });
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this.layout.publishLayoutChange(
        {
          sidebarStyle: 'full',
          sidebarCompactToggle: false,
        },
        { transitionClass: true }
      );
    }

    // * --> compact
    this.layout.publishLayoutChange(
      {
        sidebarStyle: 'compact',
        sidebarCompactToggle: true,
      },
      { transitionClass: true }
    );
  }

  onSearch(e) {
    //   console.log(e)
  }

  openCheckDuplicateDialog() {
    let dialogref = this.dialog.open(CheckDuplicatePopupComponent, {
      width: '850px',
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
